import type { JSX } from 'preact/jsx-runtime';
import type { RouteProps } from '../../util';
import { AdminUserPage } from '../components/pages/admin-user-page';


export const AdminUserRoute = ({ userId }: RouteProps): JSX.Element => {
	return <AdminUserPage userId={ userId } key={ userId }/>;
};